import { UploadData } from './types';

export function generateKey({ provider, id, file, categoryPreview }: UploadData): string {
    return `${provider}${categoryPreview ? '/category' : ''}/${id}/${Date.now()}-${file.type.replace('/', '-')}`;
}
